import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import MapElement from "./MapElement";
import FeatureDrawer from '../helpers/FeatureDrawer';
import { Circle, Fill, Stroke, Style, Icon } from 'ol/style.js';


export default class MapCSVPoints extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent)
    }

    drawLayer(data, projection) {
        const layerData = data
        const dark = this.mapModel.dark

        const style = new Style({
            image: new Circle({
                fill: new Fill({
                    color: [0, 0, 0, 1] // "#00008c"
                }),
                radius: 2,
                stroke: new Stroke({
                    color: [0, 0, 0, 1],
                    width: 1
                })
            }),
        })

        const source = new VectorSource();
        this.layer = new VectorLayer({
            parentId: this.id,
            source: source,
            style: style
        });

        const points = [];

        // user featuredrawer to move points for projection
        const featureDrawer = new FeatureDrawer(projection, this.mapModel.projection);

        layerData.forEach(csvLine => {
            if (csvLine[1] != 'X1') {
                points.push(featureDrawer.drawFeature({ type: "POINT", x: Number(csvLine[1]), y: Number(csvLine[2]) }))
            }
        });

        source.addFeatures(points);

        if (this.parent && this.parent.layer) {
            this.parent.layer.getLayers().push(this.layer);
        }
    }
}
